import React from 'react';

/**
 * SubTabBar — universal tab strip for section sub-navigation.
 *
 * Props:
 *   tabs     — [{ label, path?, query?, onClick?, icon? }]
 *   accent   — CSS color, default var(--accent)
 *   activePath — current location.pathname
 *   activeSearch — current location.search (for query matching)
 *   onNavigate — (path) => void, SPA navigation
 */
export default function SubTabBar({ tabs = [], accent = 'var(--accent)', activePath = '', activeSearch = '', onNavigate }) {
  if (!tabs || tabs.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      borderBottom: '1px solid var(--border)',
      background: 'transparent',
      flexShrink: 0,
      overflowX: 'auto',
    }}>
      {tabs.map(tab => {
        const isActive = tab.path
          ? activePath === tab.path
          : tab.query
            ? activeSearch.includes(tab.query)
            : false;

        return (
          <button
            key={tab.label}
            onClick={() => {
              if (tab.onClick) return tab.onClick();
              if (tab.path && onNavigate) return onNavigate(tab.path);
              if (tab.query && onNavigate) return onNavigate('?' + tab.query);
            }}
            style={{
              padding: '10px 16px',
              minHeight: 44,
              background: 'transparent',
              border: 'none',
              borderBottom: isActive ? `2px solid ${accent}` : '2px solid transparent',
              marginBottom: '-1px',
              color: isActive ? 'var(--text-primary)' : 'var(--text-muted)',
              cursor: 'pointer',
              fontSize: '13px',
              fontFamily: 'inherit',
              transition: 'color 150ms ease, border-color 150ms ease',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
            onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = 'var(--text-secondary)'; }}
            onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = 'var(--text-muted)'; }}
          >
            {tab.icon && <span style={{ display: 'flex' }}>{tab.icon}</span>}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
